// Case Western Reserve University's undergraduate majors (#2748). Read on
// 2026-10-01 from the official 2026-27 General Bulletin's Academic Programs
// page (bulletin.case.edu/academic-programs/), filtered to the "Bachelor's"
// program type: every bachelor's line kept, each under the school the
// Bulletin tags it with (a few programs hosted by another school's
// department, such as Biochemistry and Economics, are tagged College of Arts
// and Sciences there). Minors, certificates, combined bachelor's to master's
// programs and graduate programs left out. Degree abbreviations are the
// Bulletin's own (BA, BS, BSE, BSN, BSM). The KB's majors list was the
// starting point; the Bulletin wins.
const majors = {
    "slug": "case-western-reserve-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree program in CWRU's official 2026-27 General Bulletin, grouped by the school the Bulletin lists it under, with the degree it leads to. Minors, certificates, combined bachelor's to master's programs and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts and Sciences",
            "source": {
                "label": "CWRU 2026-27 General Bulletin, Academic Programs (Bachelor's)",
                "url": "https://bulletin.case.edu/academic-programs/"
            },
            "majors": [
                {
                    "name": "Ancient Near Eastern and Egyptian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Anthropology",
                    "degree": "BA"
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Art History",
                    "degree": "BA"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BA"
                },
                {
                    "name": "Asian Studies",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BA"
                },
                {
                    "name": "Astronomy",
                    "degree": "BS"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BA"
                },
                {
                    "name": "Biochemistry",
                    "degree": "BS"
                },
                {
                    "name": "Biology",
                    "degree": "BA"
                },
                {
                    "name": "Biology",
                    "degree": "BS"
                },
                {
                    "name": "Chemical Biology",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BA"
                },
                {
                    "name": "Chemistry",
                    "degree": "BS"
                },
                {
                    "name": "Chinese",
                    "degree": "BA"
                },
                {
                    "name": "Classics",
                    "degree": "BA"
                },
                {
                    "name": "Cognitive Science",
                    "degree": "BA"
                },
                {
                    "name": "Communication Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Computer Science",
                    "degree": "BA"
                },
                {
                    "name": "Dance",
                    "degree": "BA"
                },
                {
                    "name": "Data Science and Analytics",
                    "degree": "BA"
                },
                {
                    "name": "Economics",
                    "degree": "BA"
                },
                {
                    "name": "English",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Geology",
                    "degree": "BA"
                },
                {
                    "name": "Environmental Studies",
                    "degree": "BA"
                },
                {
                    "name": "French",
                    "degree": "BA"
                },
                {
                    "name": "French and Francophone Studies",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Geological Sciences",
                    "degree": "BS"
                },
                {
                    "name": "German",
                    "degree": "BA"
                },
                {
                    "name": "Gerontological Studies",
                    "degree": "BA"
                },
                {
                    "name": "History",
                    "degree": "BA"
                },
                {
                    "name": "History and Philosophy of Science",
                    "degree": "BA"
                },
                {
                    "name": "Humanity and Technology",
                    "degree": "BA"
                },
                {
                    "name": "International Studies",
                    "degree": "BA"
                },
                {
                    "name": "Japanese Studies",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BA"
                },
                {
                    "name": "Mathematics",
                    "degree": "BS"
                },
                {
                    "name": "Mathematics and Physics",
                    "degree": "BS"
                },
                {
                    "name": "Music",
                    "degree": "BA"
                },
                {
                    "name": "Music Education",
                    "degree": "BS"
                },
                {
                    "name": "Natural Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Neuroscience",
                    "degree": "BS"
                },
                {
                    "name": "Nutrition",
                    "degree": "BA"
                },
                {
                    "name": "Nutrition",
                    "degree": "BS"
                },
                {
                    "name": "Nutritional Biochemistry and Metabolism",
                    "degree": "BA"
                },
                {
                    "name": "Nutritional Biochemistry and Metabolism",
                    "degree": "BS"
                },
                {
                    "name": "Origins Sciences",
                    "degree": "BA"
                },
                {
                    "name": "Philosophy",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BA"
                },
                {
                    "name": "Physics",
                    "degree": "BS"
                },
                {
                    "name": "Political Science",
                    "degree": "BA"
                },
                {
                    "name": "Pre-Architecture",
                    "degree": "BA"
                },
                {
                    "name": "Psychology",
                    "degree": "BA"
                },
                {
                    "name": "Religious Studies",
                    "degree": "BA"
                },
                {
                    "name": "Sociology",
                    "degree": "BA"
                },
                {
                    "name": "Spanish",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BA"
                },
                {
                    "name": "Statistics",
                    "degree": "BS"
                },
                {
                    "name": "Systems Biology",
                    "degree": "BS"
                },
                {
                    "name": "Teacher Education",
                    "degree": "BA"
                },
                {
                    "name": "Theater Arts",
                    "degree": "BA"
                },
                {
                    "name": "Women's, Gender, and Sexuality Studies",
                    "degree": "BA"
                },
                {
                    "name": "World Literature",
                    "degree": "BA"
                }
            ]
        },
        {
            "name": "Case School of Engineering",
            "source": {
                "label": "CWRU 2026-27 General Bulletin, Academic Programs (Bachelor's)",
                "url": "https://bulletin.case.edu/academic-programs/"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Artificial Intelligence",
                    "degree": "BS"
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Civil Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Computer Science",
                    "degree": "BS"
                },
                {
                    "name": "Data Science and Analytics",
                    "degree": "BS"
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Engineering Physics",
                    "degree": "BSE"
                },
                {
                    "name": "General Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "BSE"
                },
                {
                    "name": "Polymer Science and Engineering",
                    "degree": "BSE"
                }
            ]
        },
        {
            "name": "Frances Payne Bolton School of Nursing",
            "source": {
                "label": "CWRU 2026-27 General Bulletin, Academic Programs (Bachelor's)",
                "url": "https://bulletin.case.edu/academic-programs/"
            },
            "majors": [
                {
                    "name": "Nursing",
                    "degree": "BSN"
                }
            ]
        },
        {
            "name": "Weatherhead School of Management",
            "source": {
                "label": "CWRU 2026-27 General Bulletin, Academic Programs (Bachelor's)",
                "url": "https://bulletin.case.edu/academic-programs/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BS"
                },
                {
                    "name": "Business Information Technology",
                    "degree": "BSM"
                },
                {
                    "name": "Business Management",
                    "degree": "BSM"
                },
                {
                    "name": "Finance",
                    "degree": "BSM"
                },
                {
                    "name": "Marketing",
                    "degree": "BSM"
                }
            ]
        }
    ]
};

export default majors;
